import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import SkinnyBanner from 'web_component_library/skinnyBanner';
import { getImageUrl } from '../../../utils/imageHelper';
import { selectPopupModals } from '../../containers/contentfulHoc/selectors';
import { ModalContext } from '../modal/modalContext';
import Modal from '../modalComponent';

const SkinnyBannerComponent = ({
  backgroundStyle = null,
  borderColor = null,
  borderWidth = null,
  content,
  cta = null,
  desktopImage = null,
  mobileImage = null,
  variant = 'black',
}) => {
  // `placeholderUrl` is set to opt into image lazy loading
  const desktopImageWithPlaceholder = desktopImage;
  const mobileImageWithPlaceholder = mobileImage;

  if (desktopImage && desktopImage?.fields) {
    desktopImageWithPlaceholder.placeholderUrl = getImageUrl(
      desktopImage.fields.file.url,
    );
  }
  if (mobileImage && mobileImage?.fields) {
    mobileImageWithPlaceholder.placeholderUrl = getImageUrl(
      mobileImage.fields.file.url,
    );
  }

  const popupModals = useSelector(selectPopupModals());

  const { showModal } = useContext(ModalContext);
  const onRequestClose = null;

  const openPopupHandler = modalIdentifier => {
    showModal(Modal, {
      ...popupModals[modalIdentifier],
      onRequestClose,
    });
  };

  if (!content) {
    return null;
  }

  return (
    <SkinnyBanner
      backgroundStyle={backgroundStyle}
      borderColor={borderColor}
      borderWidth={borderWidth}
      content={content}
      cta={cta}
      handleButtonClick={() => {}}
      handleContainerClick={() => {}}
      openPopup={openPopupHandler}
      desktopImage={desktopImageWithPlaceholder}
      mobileImage={mobileImageWithPlaceholder}
      portalRef={() => {}}
      variant={variant}
    />
  );
};

export default SkinnyBannerComponent;

SkinnyBannerComponent.propTypes = {
  backgroundStyle: PropTypes.object,
  borderColor: PropTypes.string,
  borderWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  content: PropTypes.object.isRequired,
  cta: PropTypes.shape({
    url: PropTypes.string,
    value: PropTypes.string,
    variant: PropTypes.string,
    type: PropTypes.string,
    openLinkInNewTab: PropTypes.bool,
  }),
  desktopImage: PropTypes.shape({
    url: PropTypes.string,
    description: PropTypes.string,
  }),
  mobileImage: PropTypes.shape({
    url: PropTypes.string,
    description: PropTypes.string,
  }),
  variant: PropTypes.oneOf(['dark', 'light']),
};
